<template>
  <v-container fluid class="HelloWorld">
    <v-row class="text-center">
      <v-col cols="12">
        <div>
          <v-img
            alt="Vuetify Logo"
            class="shrink ma-auto"
            contain
            :src="require('@/assets/images/layouts/logo.svg')"
            transition="scale-transition"
            width="200"
          />
        </div>
        <div class="ma-2">
          <v-img
            alt="Vuetify Logo"
            class="shrink ma-auto"
            contain
            :src="require('@/assets/images/layouts/logo_text.svg')"
            transition="scale-transition"
            width="400"
          />
        </div>
      </v-col>

      <v-col class="mb-4">
        <span class="ct-font-FY display-2 font-weight-bold mb-3">
          頁面建置中
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({})
};
</script>

<style lang="scss" scoped>
.HelloWorld {
  min-height: 100%;
  filter: contrast(0.5);
  background-size: cover;
  background-image: url("~@/assets/images/home/sect3_bg.png");
}
</style>
